import React from 'react';
import { DollarSign, Users } from 'lucide-react';

const Skeleton = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 ${className}`} />
);

const MobileStatsSection = ({ stats, loading, error }) => {
  if (error) {
    return (
      <div className="mb-8 p-3 rounded-lg border border-red-200 bg-red-50 text-xs text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 mb-8">
      <div className="p-4 rounded-lg border border-notion-border bg-white shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-notion-text-light font-medium">Pipeline Value</span>
          <div className="bg-status-success-bg p-1 rounded">
            <DollarSign className="w-3 h-3 text-status-success-text" />
          </div>
        </div>
        <div className="flex items-baseline gap-3">
          {loading ? (
            <Skeleton className="h-7 w-24" />
          ) : (
            <>
              <span className="text-2xl font-semibold text-notion-text">{stats.pipelineValue}</span>
              {stats.pipelineChange && (
                <span className="text-xs font-medium text-status-success-text bg-status-success-bg px-1.5 py-0.5 rounded">
                  {stats.pipelineChange}
                </span>
              )}
            </>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="p-4 rounded-lg border border-notion-border bg-white shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-notion-text-light font-medium">New Leads</span>
            <Users className="w-3 h-3 text-notion-text-light" />
          </div>
          <div className="flex items-baseline gap-2">
            {loading ? (
              <Skeleton className="h-6 w-16" />
            ) : (
              <>
                <span className="text-xl font-semibold text-notion-text">{stats.newLeadsToday}</span>
                <span className="text-[10px] text-notion-text-light">vs {stats.newLeadsYesterday} yest.</span>
              </>
            )}
          </div>
        </div>

        <div className="p-4 rounded-lg border border-notion-border bg-white shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-notion-text-light font-medium">Action Req.</span>
            <Users className="w-3 h-3 text-notion-text-light" />
          </div>
          <div className="flex items-baseline gap-2">
            {loading ? (
              <Skeleton className="h-6 w-12" />
            ) : (
              <>
                <span className="text-xl font-semibold text-notion-text">{stats.actionRequired}</span>
                <span className="text-[10px] font-medium text-notion-text-light">Actionable Leads</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileStatsSection;
